import React, { useCallback, useEffect, useState } from "react";
import { Marker, Polygon, Rectangle, Tooltip, useMap } from "react-leaflet";
import { createConicGradientSVGCircleStroked, getIconMarkerCluster, getSVGIcon, getSVGIconV2 } from "./helper";
import "leaflet/dist/leaflet.css";
import { MarkerPopup } from "./LayersHelpers";
import L from 'leaflet';
import MarkerClusterGroup from "react-leaflet-markercluster";
import { useSelector, useDispatch } from "react-redux";
import { setPopup } from "../../store/reducers/helpersReducer";
import { ktpIcon, projectStatusOreolIcon } from "./icons";
import { renderToString } from 'react-dom/server'
import { zLayers } from "./ControlLayer";

// Кеш для иконок кластеров, чтобы не пересобирать SVG для одинаковых распределений
const clusterIconCache = new Map();
const MAX_CLUSTER_CACHE_SIZE = 500; // Ограничение размера кэша кластеров

const statusColors = {
    'default': { fill: '#F57795', stroke: '#C76179' },
    'accounting': { fill: '#ff0000', stroke: '#AB0000' },
    'construction': '#ff2b2b',
    'reconstruction': '#2196F3',
    'replacement': '#18c218'
}

const textLength = {
    1: [300, 330],
    2: [300, 330],
    3: [280, 440],
    4: [220, 480],
    5: [200, 500]
}

const measureText = (text, size, maxWidth = null) => {
    const temp = document.createElement('span');
    // temp.style.visibility = 'hidden';

    temp.style.font = `${size}px 'Roboto-Light', sans-serif`;
    if (maxWidth) {
        temp.style.display = 'block'
        temp.style.maxWidth = `${maxWidth}px`
        temp.style.width = `${maxWidth}px`
    } else {
        temp.style.whiteSpace = 'nowrap';
    }
    temp.style.lineHeight = '1'
    document.body.appendChild(temp);
    temp.innerHTML = text;
    const rect = temp.getBoundingClientRect();
    document.body.removeChild(temp);
    return { width: rect.width, height: rect.height }
};

export const LayerTransformers = props => {

    const map = useMap()
    const [mapState, setMapState] = useState({ zoom: map.getZoom(), bounds: map.getBounds() });

    // Подписываемся на события карты для обновления при перемещении/зуме
    useEffect(() => {
        const handleMapChange = () => {
            setMapState({ zoom: map.getZoom(), bounds: map.getBounds() });
        };



        map.on('zoomend', handleMapChange);
        map.on('moveend', handleMapChange);
        return () => {
            map.off('zoomend', handleMapChange);
            map.off('moveend', handleMapChange);
        };
    }, [map]);


    const dialFilter = useSelector((state) => state.state.filter.dial);
    const transformers = useSelector((state) => state.state.electricityFiltered.transformers);
    const { printing, drawing } = useSelector(
        (state) => state.helper
    );


    const createClusterCustomIcon = useCallback((cluster) => {
        // let type = 'transformer'
        // if (cluster.getAllChildMarkers().find(child => child.options.status === 'accounting')) {
        //     type = 'transformer_accounting'
        // }
        // var types = []
        // cluster.getAllChildMarkers().map(child => {
        //     // if (child.options.trigger > triggerMaxPriority) {
        //     //     triggerMaxPriority = child.options.trigger

        //     // } 
        //     if (['2', '3', '4', '7'].includes(child.options.layer)) types.push('ps_ktp_' + child.options.layer)
        // })
        // return getIconMarkerCluster(cluster.getAllChildMarkers().length, type, types.filter(f => f), props.viewProjectStatus)


        let type = 'default'
        if (cluster.getAllChildMarkers().find(child => child.options.status.includes('accounting'))) {
            type = 'accounting'
        }
        var types = {}
        let def = 0
        // const t = []
        cluster.getAllChildMarkers().forEach(child => {

            // if (child.options.trigger > triggerMaxPriority) {
            //     triggerMaxPriority = child.options.trigger

            // } 
            if (!['2', '3', '4', '7'].includes(child.options.layer)) {
                def = def + 1
                return
            }
            const type = 'ps_ktp_' + child.options.layer
            if (!types[type]) types[type] = 0
            types[type] = types[type] + 1
            // t.push(child.options.status === 'default' ? child.options.type : child.options.status)
        })

        const totalCount = Object.values(types).reduce((a, v) => a + v, 0)

        // Попытка взять иконку из кеша по сигнатуре распределения типов
        const sortedEntries = Object.entries(types).sort((a, b) => a[0].localeCompare(b[0]))
        const cacheKey = `t:${type};d:${JSON.stringify(sortedEntries)}`
        if (clusterIconCache.has(cacheKey)) {
            console.log('in cache', cacheKey, clusterIconCache.size)
            return clusterIconCache.get(cacheKey)
        }

        // Очищаем кеш если он переполнен (удаляем самую старую запись)
        if (clusterIconCache.size >= MAX_CLUSTER_CACHE_SIZE) {
            const firstKey = clusterIconCache.keys().next().value;
            clusterIconCache.delete(firstKey);
        }



        const svgIcon = ` 
            ${props.viewProjectStatus ?
                `<div style='position:absolute; bottom: 0; display:flex; margin-left: -8px; margin-bottom: -8px'>
                    ${createConicGradientSVGCircleStroked(Object.entries(types).map(v => ({ angle: (v[1] / totalCount) * 360, color: `var(--${v[0]})`, type: v[0] })))}
                </div>`
                : ''
            }
            <div style='position:absolute; bottom: 0; display:flex; margin-left: 0'>
                ${renderToString(ktpIcon(type, 24, 24))}
            </div>
            <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -8px; margin-left: -7px'>
                <svg  class="shadow1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512">
                    <circle cx="256" cy="256" r="236" fill="#5A5985" stroke="#5A5985" stroke-width="0" fill-opacity="0.7"/>
                </svg>
            </div>
            <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -8px; margin-left: -7px'>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                    <text x="290" y="256" font-size="${textLength[(totalCount + def).toString().length][0]}" fill="white" lengthAdjust="spacing" text-anchor="middle" textLength="${textLength[(totalCount + def).toString().length][1]}" alignment-baseline="middle" font-style="bold" >
                    ${totalCount + def}
                    </text>
                </svg>
            </div>   
            `

        const icon = new L.DivIcon({
            html: svgIcon,
            className: `cluster-icon-${type}`, // чтобы убрать стандартные стили
            iconSize: [24, 24], // Размер иконки
            popupAnchor: [0, 0],
            tooltipAnchor: [-2, 0],
            iconAnchor: [12, 12] // Координаты якоря (центр нижнего края)
        });
        clusterIconCache.set(cacheKey, icon)

        return icon
    }, [props.viewProjectStatus]);


    const handleMarkerClick = useCallback((e) => {
        map.fire('openPopup', {
            class: 'transformer',
            mark: transformers.find(p => p.fid === e.target.options.data),
        });
    }, [map, transformers]);

    useEffect(() => {
        preloadPillarsCommonIcons()

        return () => clearCaches()
    }, [])


    if (!transformers) {
        return <></>
    }

    //для усечения маркеров находящихся в невидимой области
    const bounds = printing ? new L.LatLngBounds([printing.bounds.south, printing.bounds.west], [printing.bounds.north, printing.bounds.east]) : mapState.bounds
    const nePixel = map.project(bounds.getNorthEast());
    const swPixel = map.project(bounds.getSouthWest());

    //для позиционирования надписей
    const posBounds = printing && props.posBounds ? new L.LatLngBounds([printing.posBounds.south, printing.posBounds.west], [printing.posBounds.north, printing.posBounds.east]) : mapState.bounds
    const posnePixel = map.project(posBounds.getNorthEast());
    const posswPixel = map.project(posBounds.getSouthWest());






    const defaultFontSize = window.innerWidth < 768 ? 12 : 14
    let fntsize = printing ? defaultFontSize + 1 : defaultFontSize


    const markers = transformers.map(mark => {
        // if (!mark.x_y_coord || mark.x_y_coord === "") {
        //     return null;
        // }
        const markPixel = map.project(mark.coords)
        if ((markPixel.x < swPixel.x) || (markPixel.x > nePixel.x) || (markPixel.y < nePixel.y) || (markPixel.y > swPixel.y)) return null
        let text = null
        let size = null
        let position = null
        let twoLineText = false

        if (dialFilter && dialFilter.labelsOpacity[0] > 0) {
            position = 'topright'
            text = `${mark.name.replace(/^.ТП/, 'КТП')}${mark.nickname ? '(' + mark.nickname + ')' : ''}`
            size = printing ? mark.textSize : mark.textSize
        }
        if (printing && size) {
            size = { width: size.width * 1.085, height: size.height + 1 }
        }
        if (position && size) {

            //Если выходит за пределы справа, то перемещаем текст влево
            if ((markPixel.x + size.width + 20) > posnePixel.x) {
                position = 'topleft'
            }
            //Если и слева выходит за пределы, то смотри в какой стороне больше места, перемещаем туда, и переносим текст на вторую строку
            if (position === 'topleft' && (markPixel.x - size.width - 12) < posswPixel.x) {
                position = (markPixel.x - posswPixel.x) > (posnePixel.x - markPixel.x) ? 'topleft' : 'topright'

            }
            if (twoLineText) {
                const maxWidth = position === 'topleft' ? (markPixel.x - posswPixel.x - 12) : (posnePixel.x - markPixel.x - 12)
                size = measureText(text, fntsize, maxWidth)
            }
            if ((markPixel.y - size.height) < posnePixel.y) {
                position = position === 'topright' ? 'bottomright' : 'bottomleft'
            }

        }



        let bounds = [[markPixel.x - 4, markPixel.y - 4], [markPixel.x + 4, markPixel.y + 4]]

        // let pos = map.project(mark.coords)
        // let ne = null
        // let sw = null
        // let bb = null
        // if (text) {
        //     switch (position) {
        //         case 'topright':
        //             sw = { x: pos.x, y: pos.y - size.height + 2 }
        //             ne = { x: pos.x + size.width + 8, y: pos.y - size.height - 8 }
        //             break;
        //         case 'topleft':
        //             sw = { x: pos.x - size.width - 8, y: pos.y - size.height + 2 }
        //             ne = { x: pos.x, y: pos.y - size.height - 8}
        //             break;
        //         case 'bottomright':
        //             sw = { x: pos.x, y: pos.y + size.height - 4 }
        //             ne = { x: pos.x + size.width + 8, y: pos.y }
        //             break;
        //         case 'bottomleft':
        //             sw = { x: pos.x - size.width - 8, y: pos.y + size.height - 4 }
        //             ne = pos
        //             break;
        //     }
        // }

        // if (ne && sw) {
        //     bb = new L.LatLngBounds(map.unproject(sw), map.unproject(ne))
        // }
        return (
            [<Marker
                position={mark.coords}
                // icon={getSVGIcon(type, props.zoom && props.zoom > 15 ? (mark.tp ? `${mark.tp}${mark.nickname ? '(' + mark.nickname + ')': ''}` : mark.name) : null)}

                icon={transformerSvgIcon({ ...mark, text: { text, size, position, fontSize: fntsize }, mount_status: props.viewMounted ? mark.mount_status : 0 }, props.viewProjectStatus)}
                key={printing ?
                    `printing_${mark.fid}_${mark.status}` :
                    drawing ?
                        `drawing_${mark.fid}_${mark.status}` :
                        `${mark.fid}_${mark.status}`}
                data={mark.fid}
                type={mark.type}
                status={mark.status}
                layer={mark.layer}
                spec={mark.spec}
                name={`${text}${mark.town ? ' ' + mark.town : ''}`}
                interactive={!drawing?.state}
                pane="transformersPane"
                {...(printing && {
                    bounds: L.latLngBounds(map.unproject(bounds[0]), map.unproject(bounds[1])),
                    legend: mark.type === 'transformer_accounting' ? 'Предписания' : ''
                })}
                tags={mark.tags}



                {...(!drawing?.state && {
                    eventHandlers: {

                        click: (e) => {
                            map.fire('openPopup', {
                                class: 'transformer',
                                mark: mark
                            })

                        }
                    }
                })}

            >
                {/* <MarkerPopup
                host={mark}
                key={`popup_${mark.fid}`}
                k={`popup_${mark.fid}`}
                ps={props.ps ? props.ps.find(p => p.fid === mark.ps_id) : null}
                position={mark.coords}
            /> */}
                {!drawing &&
                    <Tooltip
                        direction="top"
                        key={`${mark.fid}_tooltip`}
                        opacity={1}


                    >

                        {mark.name}{mark.nickname ? '(' + mark.nickname + ')' : ''}
                    </Tooltip>
                }
                <Polygon
                    positions={mark.coordinates}
                    color={statusColors[mark.status]?.stroke}
                    fillColor={statusColors[mark.status]?.fill}
                    fillOpacity={0.5}
                    fillRule="evenodd"
                    pathOptions={{
                        weight: 2
                    }}

                >


                </Polygon>
                {/* {
                    bb ? <Rectangle
                        bounds={bb}
                    /> : null
                } */}

            </Marker>




            ]);
    });
    // return markers;

    return <MarkerClusterGroup
        // key={Date.now()}
        maxClusterRadius={props.type === "transformer" ? 60 : 30}
        iconCreateFunction={createClusterCustomIcon}
        removeOutsideVisibleBounds
        zoomToBoundsOnClick={true}
        spiderfyOnEveryZoom={false}
        showCoverageOnHover={false}
        animate={false}
        type={'cluster'}
        clusterPane="transformersPane"
        disableClusteringAtZoom={18}
        chunkedLoading={true}
        chunkInterval={200}
        chunkDelay={50}
    // polygonOptions={{ color: colorMap[props.type], weight: 2 }}

    >
        {markers}
    </MarkerClusterGroup>

    //     return <MarkerClusterGroup key={Date.now()} maxClusterRadius={200} >
    //     {markers}
    // </MarkerClusterGroup>
}



function getSvgIcon(mark, viewProjectStatus) {

    const tooltipAnchor = [0, -14]
    const popupAnchor = [0, -14]
    let svgIcon = ''

    svgIcon += `
            <div style='position:absolute; bottom: 0; display:flex; margin-bottom: 0px; margin-left: -1px'>
                ${renderToString(ktpIcon(mark.status, 24, 24))}
            </div>`

    if (mark.status === 'accounting') {
        svgIcon += `
           <div style='position:absolute; bottom: 0; display:flex; margin-left: -6px; margin-bottom: -6px'>
                    <svg width="36" height="36" viewBox="0 0 90 90">
                        <circle id="ring" r="45" cx="45" cy="45" fill="${statusColors[mark.status].fill}" />
                    </svg>
                </div>`
    }
    if (viewProjectStatus && mark.layer && ['2', '3', '4', '7'].includes(mark.layer)) {
        svgIcon += `
            <div style='position:absolute; bottom: 0; display:flex; margin-left: -11px; margin-bottom: -10px; transform: ${mark.text?.position?.includes('right') ? ' scaleX(-1)' : ''}'>
                ${renderToString(projectStatusOreolIcon('ktp', Number(mark.layer), 44))}
            </div>`
    }
    // svgIcon = `
    //         <div style='position:absolute; bottom: 0; display:flex; margin-bottom: 12px; margin-left: 0'>
    //             <svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 3.3994775 7.3981276" version="1.1" id="svg1">
    //             <defs id="defs1"/>
    //             <g id="layer1" transform="translate(-103.45208,-144.7271)">
    //                 <g id="g6576" transform="matrix(0.08466653,0,0,0.08466653,-11.079747,62.222025)">
    //                 <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="${statusColors[mark.status].stroke}" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="${statusColors[mark.status].fill}" stroke-linecap="square" id="g6553" style="fill-rule:evenodd">
    //                     <path vector-effect="none" d="m 1009.25,378.107 c 0,9.785 -7.94,17.716 -17.72,17.716 -9.785,0 -17.717,-7.931 -17.717,-17.716 0,-9.785 7.932,-17.717 17.717,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6552"/>
    //                 </g>
    //                 <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="${statusColors[mark.status].stroke}" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="${statusColors[mark.status].fill}" stroke-linecap="square" id="g6554" style="fill-rule:evenodd">
    //                     <path vector-effect="none" d="m 1009.25,354.485 c 0,9.784 -7.94,17.716 -17.72,17.716 -9.785,0 -17.717,-7.932 -17.717,-17.716 0,-9.785 7.932,-17.717 17.717,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6553"/>
    //                 </g>
    //                 <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="${statusColors[mark.status].stroke}" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill="none" stroke-linecap="square" id="g6555" style="fill-rule:evenodd">
    //                     <path vector-effect="none" d="m 991.53,313.146 v 23.622" fill-rule="evenodd" id="path6554"/>
    //                 </g>
    //                 </g>
    //             </g>
    //             </svg>
    //         </div>
    //         ${mark.status === 'accounting' ? `
    //             <div style='position:absolute; bottom: 0; display:flex; margin-left: -6px; margin-bottom: 6px'>
    //                 <svg width="36" height="36" viewBox="0 0 90 90">
    //                     <circle id="ring" r="45" cx="45" cy="45" fill="${statusColors[mark.status].fill}" />
    //                 </svg>
    //             </div>
    //         ` : ''}
    //         ${mark.layer && statusColors[mark.layer] ? `
    //             <div style='position:absolute; bottom: 0; display:flex; margin-left: -8px; margin-bottom: 4px'>
    //                 <svg width="40" height="40" viewBox="0 0 90 90">
    //                     <circle r="40" cx="45" cy="45" fill=none stroke="${statusColors[mark.layer]}" stroke-width="8" />
    //                 </svg>
    //             </div>
    //         ` : ''}

    //         `
    if (mark.text && mark.text.text) {
        let offset = 14
        let mleft = 12 + 8
        let mbottom = offset
        switch (mark.text.position) {
            case 'topleft':
                mleft = `-${mark.text.size.width - 4}`
                break;
            case 'bottomright':
                mbottom = `-${mark.text.size.height - offset}`
                break;
            case 'bottomleft':
                mleft = `-${mark.text.size.width - 4}`
                mbottom = `-${mark.text.size.height - offset}`
                break;
        }



        if (mark.text.size) {
            svgIcon += `<div style='position:absolute; bottom: 0; display:flex;  margin-left: ${mleft}px; margin-bottom: ${mbottom}px; z-index: 500'>
                        <div style='color: var(--${mark.type}_${mark.status});font-weight: normal; font-size: ${mark.text.fontSize}px; font-family: Arial, sans-serif; width: ${mark.text.size.width}px; height: ${mark.text.size.height} ; line-height: 1;
                            text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
                                1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff; text-align: ${mark.text.position.includes('right') ? 'start' : 'end'}; '>
                                <span>${mark.text.text}</span>
                        </div>
                    </div>`



        } else {
            svgIcon += `<div style='position:absolute; bottom: 0; display:flex; margin-left: 20px; margin-bottom: 10px'>
                    <div style='color: var(--${mark.type}_${mark.status});font-weight: normal; font-size: ${mark.text.fontSize || 14}px; font-family: Arial, sans-serif;
                        text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
                            1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;  white-space: nowrap; text-align: center   ;'>
                            ${mark.text.text}
                    </div>
                </div>`
        }



    }
    // const offs = type.includes('trans') ? -2 : -7
    return new L.DivIcon({
        html: svgIcon,
        className: `icon-${mark.type}`, // чтобы убрать стандартные стили
        iconSize: [24, 24], // Размер иконки
        popupAnchor: popupAnchor,
        tooltipAnchor: tooltipAnchor,
        iconAnchor: [12, 12] // Координаты якоря (центр нижнего края)
    });

}





// Кеш для иконок - добавляем в начало файла после импортов
const iconCache = new Map();
const MAX_CACHE_SIZE = 1000;


// Функция для очистки кешей (может быть полезна для освобождения памяти)
const clearCaches = () => {
    iconCache.clear();
    clusterIconCache.clear();
    console.log('Кеши очищены');
};



// Функция для предварительного прогрева кеша наиболее часто используемых иконок
const preloadPillarsCommonIcons = () => {
    const commonStatuses = ['default', 'accounting']
    const commonTypes = ['transformers']
    const commonLayers = [null, 2, 3, 4, 7]
    const commonTextPostitions = [null, 'left', 'right']
    const commonConfigs = [];
    commonTypes.forEach(type => {
        commonStatuses.forEach(status => {
            commonLayers.forEach(layer => {
                commonTextPostitions.forEach(textPos => {
                    commonConfigs.push({
                        type,
                        status,
                        layer,
                        text: textPos ? { position: textPos } : undefined
                    });
                })
            })


        });
    });
    // Прогреваем кеш для наиболее часто используемых конфигураций (без текста)
    commonConfigs.forEach(config => {
        const mockMark = {
            ...config
        };
        const viewProjectStatus = mockMark.layer
        const cacheKey = createIconCacheKey(mockMark, viewProjectStatus);
        if (!iconCache.has(cacheKey)) {
            // Создаем базовую иконку без текста и сохраняем в кеш
            transformerSvgIcon(mockMark, viewProjectStatus);

        }
    });
    console.log(`Трансформаторы: Прогреты ${commonConfigs.length} базовых иконок в кеше`);
};

// Функция для мониторинга производительности кеша
export const getCacheStats = () => {
    return {
        iconCache: {
            size: iconCache.size,
            maxSize: MAX_CACHE_SIZE,
            hitRatio: iconCache.size > 0 ? (iconCache.size / MAX_CACHE_SIZE * 100).toFixed(1) + '%' : '0%'
        }
    };
};
// Функция для создания ключа кеша
function createIconCacheKey(mark, viewProjectStatus) {
    // Кэшируем только базовые иконки без текста
    let key = `${mark.type}_${mark.status}`
    if (mark.text?.position) {
        key = key + `_txt-${mark.text.position.includes('right') ? 'right' : 'left'}`
    }
    if (viewProjectStatus) {
        key = key + `_ps-${mark.layer}`
    }
    if (mark.mount_status) {
        key = key + `_ms-${mark.mount_status}`
    }
    return key
}




export function transformerSvgIcon(mark, viewProjectStatus) {
    // Проверяем кеш
    const cacheKey = createIconCacheKey(mark, viewProjectStatus);
    let cachedIcon = null;
    if (iconCache.has(cacheKey)) {
        cachedIcon = iconCache.get(cacheKey);
    } else {
        // Очищаем кеш если он переполнен
        if (iconCache.size >= MAX_CACHE_SIZE) {
            const firstKey = iconCache.keys().next().value;
            iconCache.delete(firstKey);
        }

        var svgIcon = ''
        var popupAnchor = [0, 0]
        var tooltipAnchor = [0, -12]

        // Свечение монтажа (должно быть первым, чтобы быть под иконкой)
        if (mark.mount_status > 0) {
            svgIcon += `<div style='position:absolute; bottom: 0; display:flex; margin-left: -9px; margin-bottom: -9px'>
                        <svg width="42" height="42" viewBox="0 0 100 100">
                            <defs>
                            <radialGradient id="TransformerRadialGradient1">
                                <stop offset="0%" stop-color="#00dd00" stop-opacity="0" />
                                <stop offset="50%" stop-color="#00dd00" stop-opacity="0.7" />
                                <stop offset="100%" stop-color="#00dd00" stop-opacity="0" />
                            </radialGradient>
                            <radialGradient id="TransformerRadialGradient2">
                                <stop offset="0%" stop-color="#ffa000" stop-opacity="0" />
                                <stop offset="50%" stop-color="#ffa000" stop-opacity="0.7" />
                                <stop offset="100%" stop-color="#ffa000" stop-opacity="0" />
                            </radialGradient>
                            </defs>
                            <circle r="50" cx="50" cy="50" fill="url(#TransformerRadialGradient${mark.mount_status === 2 ? 1 : 2})" />
                        </svg>
                    </div>
                    `
        }

        // Используем предварительно созданные части
        svgIcon += `
            <div style='position:absolute; bottom: 0; display:flex; margin-bottom: 0px; margin-left: -1px'>
                ${renderToString(ktpIcon(mark.status, 24, 24))}
            </div>`

        if (mark.status === 'accounting') {
            svgIcon += `
               <div style='position:absolute; bottom: 0; display:flex; margin-left: -6px; margin-bottom: -6px'>
                        <svg width="36" height="36" viewBox="0 0 90 90">
                            <circle id="ring" r="45" cx="45" cy="45" fill="${statusColors[mark.status].fill}" />
                        </svg>
                    </div>`
        }
        if (viewProjectStatus && mark.layer && ['2', '3', '4', '7'].includes(String(mark.layer))) {
            svgIcon += `
                <div style='position:absolute; bottom: 0; display:flex; margin-left: -11px; margin-bottom: -10px; transform: ${mark.text?.position?.includes('right') ? ' scaleX(-1)' : ''}'>
                    ${renderToString(projectStatusOreolIcon('ktp', Number(mark.layer), 44))}
                </div>`
        }

        const iconMarker = new L.DivIcon({
            html: svgIcon,
            className: `icon-${mark.type}`, // чтобы убрать стандартные стили
            iconSize: [24, 24], // Размер иконки
            popupAnchor: popupAnchor,
            tooltipAnchor: tooltipAnchor,
            iconAnchor: [12, 12] // Координаты якоря (центр нижнего края)
        });

        // Сохраняем в кеш
        iconCache.set(cacheKey, iconMarker);
        cachedIcon = iconMarker;
    }

    // Если есть текст и нужно его добавить, создаем новую иконку с текстом
    if (mark.text && mark.text.text) {
        let offset = 14
        let mleft = 12 + 8
        let mbottom = offset
        switch (mark.text.position) {
            case 'topleft':
                mleft = `-${mark.text.size.width - 4}`
                break;
            case 'bottomright':
                mbottom = `-${mark.text.size.height - offset}`
                break;
            case 'bottomleft':
                mleft = `-${mark.text.size.width - 4}`
                mbottom = `-${mark.text.size.height - offset}`
                break;
        }

        let textHtml = '';
        if (mark.text.size) {
            textHtml = `<div style='position:absolute; bottom: 0; display:flex;  margin-left: ${mleft}px; margin-bottom: ${mbottom}px; z-index: 500'>
                <div style='color: var(--${mark.type}_${mark.status});font-weight: normal; font-size: ${mark.text.fontSize}px; font-family: Arial, sans-serif; width: ${mark.text.size.width}px; height: ${mark.text.size.height} ; line-height: 1;
                    text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
                        1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff; text-align: ${mark.text.position.includes('right') ? 'start' : 'end'}; '>
                        <span>${mark.text.text}</span>
                </div>
            </div>`;
        } else {
            textHtml = `<div style='position:absolute; bottom: 0; display:flex; margin-left: 20px; margin-bottom: 10px'>
            <div style='color: var(--${mark.type}_${mark.status});font-weight: normal; font-size: ${mark.text.fontSize || 14}px; font-family: Arial, sans-serif;
                text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
                    1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;  white-space: nowrap; text-align: center   ;'>
                    ${mark.text.text}
            </div>
        </div>`;
        }

        // Создаем новую иконку с добавленным текстом
        const iconWithText = new L.DivIcon({
            html: cachedIcon.options.html + textHtml,
            className: cachedIcon.options.className,
            iconSize: cachedIcon.options.iconSize,
            popupAnchor: cachedIcon.options.popupAnchor,
            tooltipAnchor: cachedIcon.options.tooltipAnchor,
            iconAnchor: cachedIcon.options.iconAnchor
        });

        return iconWithText;
    }

    return cachedIcon;
}